import getCurrentVariantUtil from 'modules/variant/utils/get-current'

const isAvailableVariantUtil = (variant) => {
  variant = variant || getCurrentVariantUtil()
  return variant?.available
}

export default isAvailableVariantUtil
